(function () {
  var productId = window.sdoRassuranceProductId;
  var rassurance = document.querySelector('.sdo-rassurance[data-product-id="' + productId + '"]');
  if (!rassurance) return;

  var monthlyEl  = rassurance.querySelector('[data-sdo-monthly]');
  var deliveryEl = rassurance.querySelector('[data-sdo-delivery-date]');
  var loyaltyEl  = rassurance.querySelector('[data-sdo-loyalty-points]');

  var currency = rassurance.dataset.currency || 'EUR';
  var locale   = rassurance.dataset.locale || 'fr-FR';
  var perMonth = rassurance.dataset.i18nPermonth || '/ mois';
  var installmentsN = parseInt(rassurance.dataset.installments, 10) || 3;

  // currencyDisplay: 'narrowSymbol' -> affiche « £ / $ / € » au lieu de « £GB / $US »
  // (le symbole long est le comportement par defaut du francais pour les devises etrangeres).
  // Repli si un tres vieux navigateur ne connait pas narrowSymbol.
  var fmt;
  try {
    fmt = new Intl.NumberFormat(locale, { style: 'currency', currency: currency, currencyDisplay: 'narrowSymbol' });
  } catch (e) {
    fmt = new Intl.NumberFormat(locale, { style: 'currency', currency: currency });
  }

  var variantPrices = {};
  if (rassurance.dataset.variantsPrices) {
    rassurance.dataset.variantsPrices.split(';').forEach(function (pair) {
      var parts = pair.split(':');
      if (parts.length === 2) {
        variantPrices[parts[0].trim()] = parseInt(parts[1], 10);
      }
    });
  }

  function getCurrentPrice() {
    var productInfo = document.querySelector('product-information[data-product-id="' + productId + '"]')
                   || document.querySelector('product-information');
    if (productInfo) {
      var idInput = productInfo.querySelector('input[name="id"]');
      if (idInput && idInput.value && variantPrices[idInput.value]) {
        return variantPrices[idInput.value] / 100;
      }
    }
    return parseInt(rassurance.dataset.price, 10) / 100;
  }

  function updateMonthly() {
    var price = getCurrentPrice();
    if (!price || isNaN(price)) return false;
    if (monthlyEl) monthlyEl.textContent = fmt.format(price / installmentsN) + ' ' + perMonth;
    return true;
  }

  // --- Date de livraison calculee cote widget (plus de dependance Track123) ---
  // Track123 ne detecte pas la destination sur une fiche produit (pas d'adresse
  // avant commande -> retombe sur la France, prouve par test VPN US). On calcule
  // donc nous-memes : expedition = aujourd'hui + traitement (jours ouvrables
  // Mar-Ven, cutoff 14h) ; livraison = expedition + transit (jours calendaires,
  // table fournie par le snippet via data-transit-min / data-transit-max).
  var WORKING_DAYS = [2, 3, 4, 5]; // Mar, Mer, Jeu, Ven (entrepot, config Track123)
  var CUTOFF_HOUR = 14;

  function addBusinessDays(date, n, workingDays) {
    var d = new Date(date);
    var added = 0;
    while (added < n) {
      d.setDate(d.getDate() + 1);
      if (workingDays.indexOf(d.getDay()) !== -1) added++;
    }
    return d;
  }

  function addCalendarDays(date, n) {
    var d = new Date(date);
    d.setDate(d.getDate() + n);
    return d;
  }

  function sdoFmtDay(d)   { return new Intl.DateTimeFormat(locale, { day: 'numeric' }).format(d); }
  function sdoFmtMonth(d) { return new Intl.DateTimeFormat(locale, { month: 'short' }).format(d); }

  function sdoFormatRange(a, b) {
    var md = locale.slice(0, 2).toLowerCase() === 'en'; // anglais : ordre mois-jour
    var aDay = sdoFmtDay(a), bDay = sdoFmtDay(b);
    var aMon = sdoFmtMonth(a), bMon = sdoFmtMonth(b);
    if (a.getMonth() === b.getMonth() && a.getFullYear() === b.getFullYear()) {
      if (aDay === bDay) return md ? (aMon + ' ' + aDay) : (aDay + ' ' + aMon);
      return md ? (aMon + ' ' + aDay + ' – ' + bDay) : (aDay + ' – ' + bDay + ' ' + aMon);
    }
    return md ? (aMon + ' ' + aDay + ' – ' + bMon + ' ' + bDay)
              : (aDay + ' ' + aMon + ' – ' + bDay + ' ' + bMon);
  }

  function updateDelivery() {
    if (!deliveryEl) return true; // zone sans date (repli libelle sur) -> rien a faire
    var tmin = parseInt(rassurance.dataset.transitMin, 10);
    var tmax = parseInt(rassurance.dataset.transitMax, 10);
    var proc = parseInt(rassurance.dataset.processingDays, 10);
    if (isNaN(proc)) proc = 2;
    if (!tmax || isNaN(tmax)) return true;          // transit inconnu -> on laisse « — »
    if (isNaN(tmin) || !tmin) tmin = tmax;

    var now = new Date();
    var procN = proc;
    if (now.getHours() >= CUTOFF_HOUR) procN += 1;  // apres cutoff -> journee perdue
    var ship = addBusinessDays(now, procN, WORKING_DAYS);
    var dMin = addCalendarDays(ship, tmin);
    var dMax = addCalendarDays(ship, tmax);
    deliveryEl.textContent = sdoFormatRange(dMin, dMax);
    return true;
  }

  // Note (21/07/2026) : updateCustoms() a ete retiree ici. Depuis le snippet v61,
  // la fiche produit n'affiche plus d'estimation de droits de douane (portee par
  // le panier et le tiroir via sdo-douanes-panier), donc [data-sdo-customs]
  // n'existe plus dans le DOM et la fonction ne faisait plus rien.

  function updateLoyalty() {
    var loyoly = document.getElementById('loyoly-points');
    if (!loyoly) return false;
    var match = loyoly.textContent.match(/(\d+)\s+(\w+)/);
    if (match && loyaltyEl) {
      loyaltyEl.textContent = '+' + match[1] + ' ' + match[2];
      return true;
    }
    return false;
  }

  var monthlyDone = false, deliveryDone = false, loyaltyDone = false, attempts = 0;
  var maxAttempts = 25;

  function tryHydrate() {
    if (!monthlyDone) monthlyDone = updateMonthly();
    if (!deliveryDone) deliveryDone = updateDelivery();
    if (!loyaltyDone) loyaltyDone = updateLoyalty();

    attempts++;
    if ((monthlyDone && deliveryDone && loyaltyDone) || attempts >= maxAttempts) return;
    setTimeout(tryHydrate, 200);
  }

  tryHydrate();
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', tryHydrate);
  }
  window.addEventListener('load', function () {
    monthlyDone = false; deliveryDone = false; loyaltyDone = false; attempts = 0;
    tryHydrate();
  });

  // Tout ce qui depend du prix de la variante selectionnee.
  function updateVariantDependent() {
    updateMonthly();
  }

  function attachVariantListeners() {
    var productInfo = document.querySelector('product-information[data-product-id="' + productId + '"]')
                   || document.querySelector('product-information');
    if (!productInfo) return;

    var inputs = productInfo.querySelectorAll(
      'input[name="id"], variant-radios input, variant-selects input, variant-selects select'
    );
    inputs.forEach(function (input) {
      input.addEventListener('change', function () {
        setTimeout(updateVariantDependent, 50);
      });
    });

    var hiddenInput = productInfo.querySelector('input[name="id"]');
    if (hiddenInput) {
      new MutationObserver(function () {
        setTimeout(updateVariantDependent, 50);
      }).observe(hiddenInput, {
        attributes: true, attributeFilter: ['value']
      });
    }
  }

  attachVariantListeners();
  setTimeout(attachVariantListeners, 1000);

  ['variant:change', 'variantChange', 'productInformation:variantChange'].forEach(function (eventName) {
    document.addEventListener(eventName, function () {
      setTimeout(updateVariantDependent, 50);
    });
  });

  setTimeout(function () {
    var loyolyContainer = document.getElementById('loyoly-points');
    if (loyolyContainer) {
      new MutationObserver(updateLoyalty).observe(loyolyContainer, {
        childList: true, subtree: true, characterData: true
      });
    }
  }, 1000);
})();